// ideaGate.js — when may the idea stage generate?
//
// Extracted so the rule can be tested without mounting IdeaStage (which pulls in the api client,
// i18n, the router and the version hook). The rule is small but load-bearing: it is the whole of
// N-50's fix on the client side, and an inline `disabled={...}` expression is exactly the kind of
// thing that gets "simplified" later by someone who does not know why the clause is there.

/**
 * @param {object} o
 * @param {boolean} o.busy         a generation is already running
 * @param {boolean} o.shortfall    the quoted round cost exceeds the wallet balance
 * @param {boolean} o.isAi         the AI door ("Suggest by AI"), as opposed to "Suggest by me"
 * @param {string}  o.pickedTitle  the spark the user selected ('' when none)
 * @returns {boolean} true when the generate button must be disabled
 */
export function generateBlocked({ busy = false, shortfall = false, isAi = false, pickedTitle = '' } = {}) {
  if (busy || shortfall) return true;
  // N-50: the AI door has no free-text seed box, so a spark IS the seed. Without one there is
  // nothing specific enough to query the corpus with, retrieval returns nothing, and the door's
  // promise of an idea "grounded in your selected industry" quietly fails. The sparks load by
  // themselves, so this only ever asks the user to choose — never to go and fetch.
  if (isAi && !pickedTitle) return true;
  return false;
}
